// 导入 vue
import Vue from 'vue'
// 导入根组件
import App from './App.vue'
// 导入路由实例
import router from './router'
// 导入 vuex
import store from './store'
// 导入 rem 包
import 'amfe-flexible'
// 导入清除默认样式的包
import 'normalize.css'
// 导入字体图标的样式
import '@/style/iconfont.css'
// 导入 vant
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'
// 导入API
import api from './api/index'
import { Toast } from 'vant'
import { Overlay } from 'vant'

// 使用自定义的插件
// 使用 vant
Vue.use(Vant)
Vue.use(Toast)
Vue.use(Overlay)
Vue.config.productionTip = false
Vue.prototype.$Axios = axios
Vue.prototype.$Api = api
axios.defaults.baseURL = 'https://immers.app.smartsuperv.com'

// 创建了 vue 实例
new Vue({
  router, // 挂载路由
  store, // 挂载 vuex
  render: h => h(App) // 将根组件渲染到 vue 实例中
}).$mount('#app') // 将 vue 实例挂载到页面上 id 名为 app 的容器中
